import { render, staticRenderFns } from "./LoginSave.vue?vue&type=template&id=f86a71e2"
import script from "./LoginSave.vue?vue&type=script&lang=js"
export * from "./LoginSave.vue?vue&type=script&lang=js"
import style0 from "./LoginSave.vue?vue&type=style&index=0&id=f86a71e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports